<!-- 考勤工资管理-直连弹框 -->
<template>
    <custom-modal
        width="1000px"
        title="考勤工资管理"
        :visible="visible"
        class="attendance-and-salary-modal"
        @on-close="handleClose"
    >
        <div class="steps-wrap">
            <div  v-for="({ name, isDone }) in steps" :key="name" :class="['steps-item',isDone && 'steps-item-done']">
                <a-icon v-if="isDone" type="check-circle" theme="filled" />
                <a-icon v-else type="check-circle" />
                <p  class="steps-name">{{ name }}</p>
            </div>
        </div>
        <attendance-card :common-params="params" @reload="getData" />
        <salary-card :common-params="params" @reload="getData" />
        <bank-card :common-params="params" @reload="getData" />
        <template slot="customFooter">
            <div />
        </template>
    </custom-modal>
</template>

<script>
import { Icon as AIcon } from 'ant-design-vue'
import CustomModal from '@components/CustomModal'
import AttendanceCard from './AttendanceCard'
import SalaryCard from './SalaryCard'
import BankCard from './BankCard'
import { getProjectRecProcess } from '@/service/project/attendanceAndSalaryServices'

export default {
    name: 'AttendanceAndSalaryModal',
    components: {
        AIcon,
        CustomModal,
        AttendanceCard,
        SalaryCard,
        BankCard
    },
    props: {
        visible: Boolean,
        params: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            detail: {}
        }
    },
    computed: {
        steps() {
            return [
                {
                    name: '创建月份',
                    isDone: true
                },
                {
                    name: '考勤数据导入',
                    isDone: this.detail.attendanceCompleted
                },
                {
                    name: '工资数据导入',
                    isDone: this.detail.salaryCompleted
                },
                {
                    name: '考勤核准',
                    isDone: this.detail.attendanceCheckInitiated
                },
                {
                    name: '考勤核准通过',
                    isDone: this.detail.attendanceCheckPassed
                },
                {
                    name: '银行流水导入',
                    isDone: this.detail.bankFlowCompleted
                },
                {
                    name: '工资核准',
                    isDone: this.detail.salaryCheckInitiated
                },
                {
                    name: '工资核准通过',
                    isDone: this.detail.salaryCheckPassed
                }
            ]
        }
    },
    watch: {
        visible: {
            handler(val) {
                if (val) {
                    this.getData()
                }
            },
            immediate: true
        }
    },
    methods: {
        handleClose() {
            this.$emit('on-close')
        },
        async getData() {
            try {
                this.loading = true

                const result = await getProjectRecProcess({
                    month: this.params.attendanceMonthDesc,
                    projectCode: this.params.projectCode
                })
                this.detail = result
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss">
    .attendance-and-salary-modal {
        .ant-btn {
            width: 100%;
        }
        .steps-wrap {
            display: flex;
            justify-content: space-between;
            margin-bottom: 16px;
        }
        .steps-item {
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #c1c1c1;

            p {
                margin: 0;
                margin-left: 5px;
            }
        }
        .steps-item-done {
            color: #1890ff;
            font-weight: bold;
        }
        .steps-info {
            display: flex;

            p {
                margin-right: 16px;

                .status {
                    color: red;
                }
            }
        }
    }
</style>
